module.exports = __webpack_public_path__ + "img/u28.fa4cbc28.png";